import { Button, FormatText, GridView, Widget } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, version } from 'antd';
import {
    exportarFechamentoCicloOrcamentario,
    exportarFechamentoCicloOrcamentarioProjetoPacote,
    getFechamentoCicloAnoByFechamentoId,
} from '@app/api/fechamento';
import { CicloOrcamentarioRelatorio, Filtros } from '@app/api/relatorioCicloorcamentario';
import RelatorioCicloOrcamentarioTabela from '../RelatorioCicloOrcamentario/relatorioCicloOrcamentarioTabela';
import { hasPermission } from '@app/helpers/permissions';
import AreaExecutiveSummary from '../Dashboard/AreaExecutiveSummary';
const { Panel } = Collapse;

interface FechamentoCicloOrcamentarioProps {
    fechamentoId: string;
}

const FechamentoAreaExecutiveSummary = (props: FechamentoCicloOrcamentarioProps) => {
    const { fechamentoId } = props;
    return (

        <AreaExecutiveSummary
            fechamentoId={fechamentoId}
            telaInicial={false}
        />
    );
};

export default FechamentoAreaExecutiveSummary;
